import { fields } from '@synergy/utils';

import { ConfigurationTag } from '../tags/models/configuration-tag';

export type TagFormikValues = Omit<ConfigurationTag, 'id'>;
export const tagFormikValuesFieldNames = fields<TagFormikValues>();
